<!-- 费用明细表 -->
<template>
  <el-card class="mb5">
    <div slot="header">
      <span>{{ $t('receivablePayable.FeeBreakdown') }}</span>
    </div>
    <el-form
      ref="addBatchFee"
      :model="addBatchFee"
      label-width="0"
      class="error-form clientTableForm"
      size="small"
    >
      <el-table
        :key="tableKey"
        :data="addBatchFee.addBatchFeeList"
        :height="tableHeight"
        border
      >
        <el-table-column
          v-if="isAllowEdit" width="55" align="center"
          fixed="left"
        >
          <template #header>
            <span class="el-icon-plus addStyle" @click="addCost" />
          </template>
          <template v-slot="scope">
            <!--确定删除吗？ isAccept(对账单)为true不能删除 allowEdit为false不可删除-->
            <el-popconfirm
              v-if="!scope.row.isAccept"
              :title="$t('basicData.AreYouSureDelete')"
              @confirm="deleteCost(scope)"
            >
              <span slot="reference" class="el-icon-delete deleteStyle" />
            </el-popconfirm>
          </template>
        </el-table-column>
        <!--费用类型-->
        <el-table-column prop="feeName" :label="$t('basicData.ExpenseType')" width="180">
          <template #header>
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('basicData.ExpenseType') }}</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="formStyle">
              <div v-if="scope.row.isEdit === false">{{ scope.row.feeName }}</div>
              <el-form-item
                v-else
                :prop="'addBatchFeeList.' + scope.$index + '.feeCode'"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="scope.row.feeCode"
                  filterable
                  clearable
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  style="width: 100%;"
                  @change="addChangeFee(scope)"
                >
                  <el-option
                    v-for="item in feeTypeOption"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <!--是否生成对账单-->
        <el-table-column prop="isGenBill" :label="$t('receivablePayable.WhetherToGenerateAStatement')" width="180">
          <template v-slot="scope">
            <div>{{ scope.row.isGenBill ? $t('receivablePayable.Generated') : $t('receivablePayable.NotGenerated') }}</div>
          </template>
        </el-table-column>
        <!--是否核付-->
        <el-table-column prop="isAccept" :label="$t('receivablePayable.approvedOrNot')" width="100">
          <template v-slot="scope">
            <div>{{ scope.row.isAccept ? $t('receivablePayable.Paid1') : $t('receivablePayable.PendingPayment1') }}</div>
          </template>
        </el-table-column>
        <!--计费重量-->
        <el-table-column prop="chargeWeight" :label="$t('receivablePayable.BillableWeight')" width="100" />
        <!--应付金额-->
        <el-table-column prop="fee" :label="$t('receivablePayable.AmountDue')" width="140">
          <template #header>
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('receivablePayable.AmountDue') }}</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="formStyle">
              <div v-if="scope.row.isEdit === false">{{ scope.row.fee }}</div>
              <el-form-item
                v-else
                :prop="'addBatchFeeList.' + scope.$index + '.fee'"
                :rules="{ required: true, suffix: 2, negative: '-?', validator: priceType, trigger: ['blur', 'change'] }"
              >
                <el-input v-model="scope.row.fee" />
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <!--生成时间-->
        <el-table-column prop="operateTime" :label="$t('newOrder.BuildTime')" width="220">
          <template #header>
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('newOrder.BuildTime') }}</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="formStyle">
              <div v-if="scope.row.isEdit === false">{{ scope.row.operateTime }}</div>
              <el-form-item
                v-else
                :prop="'addBatchFeeList.' + scope.$index + '.operateTime'"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-date-picker
                  v-model="scope.row.operateTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;"
                  :placeholder="$t('basicData.SelectADatetime')"
                />
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <!--录入人员-->
        <el-table-column prop="create_user" :label="$t('receivablePayable.EnterThePerson')" width="100">
          <template v-slot="scope">
            <div class="formStyle">
              <div>{{ createUser[scope.row.createUser] }}</div>
            </div>
          </template>
        </el-table-column>
        <!--平摊方式-->
        <el-table-column
          v-if="addType === 1" prop="flatMethod" :label="$t('receivablePayable.FlatSharingMethod')"
          width="180"
        >
          <template #header>
            <div>
              <span style="color: #f00;margin-right: 5px;">*</span>
              <span>{{ $t('receivablePayable.FlatSharingMethod') }}</span>
            </div>
          </template>
          <template v-slot="scope">
            <div v-if="scope.row.isEdit === false">{{ scope.row.flatMethod }}</div>
            <el-form-item
              v-else
              :prop="'addBatchFeeList.' + scope.$index + '.flatMethod'"
              :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-select
                v-model="scope.row.flatMethod"
                filterable
                clearable
                :placeholder="$t('operationCenter.PleaseSelect')"
                style="width: 100%;"
              >
                <!--按重量平摊-->
                <el-option :label="$t('receivablePayable.SpreadEquallyByWeight')" value="1" />
                <!--按票数平摊-->
                <el-option :label="$t('receivablePayable.SplitEquallyByTheNumberOfVotes')" value="2" />
                <!--指定金额-->
                <el-option :label="$t('receivablePayable.SpecifyTheAmount')" value="3" />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!--费用来源-->
        <el-table-column prop="feeSource" :label="$t('receivablePayable.SourceOfFees')" width="180">
          <template v-slot="scope">
            <div>{{ FEE_SOURCE[scope.row.feeSource] && FEE_SOURCE[scope.row.feeSource].name || '' }}</div>
          </template>
        </el-table-column>
        <!--操作人-->
        <el-table-column prop="operator" :label="$t('basicData.Operator')" width="180">
          <template v-slot="scope">
            <div class="formStyle">
              <div>{{ scope.row.operatorName }}</div>
            </div>
          </template>
        </el-table-column>
        <!--备注-->
        <el-table-column
          prop="remark"
          :label="$t('receivablePayable.remark')"
          min-width="160" :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div v-if="scope.row.isEdit === false">{{ scope.row.remark }}</div>
            <el-form-item
              v-else
              :prop="'addBatchFeeList.' + scope.$index + '.remark'"
              :rules="{ required: false, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-input v-model="scope.row.remark" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </el-card>
</template>

<script>
import {
  apiPayableSiteExpenseDelete,
  apiPayableExpenseDelete
} from '@/api/finance/receivables';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { FEE_SOURCE } from '@/views/finance/payableManage/feesPayable/enums.js';
import { cloneDeep } from 'lodash-es';

const ADD_DATA = {
  isEdit: true,
  feeName: '', // 费用类型
  businessType: '', // 业务类型
  feeCode: '', // 费用类型代码
  feeSource: 1, // 费用来源
  fee: '', // 应付金额
  isGenBill: 0, // 是否生成对账单
  isAccept: false, // 是否核付
  isOut: 0, // 是否已出库
  billBatchNumber: '', // 对账批次号
  remark: '', // 备注
  createUser: '', // 录入人员
  operatorName: '', // 操作人
  operateTime: '', // 生成业务时间
  flatMethod: '', // 平摊方式
  chargeWeight: '' // 计费重量
};

export default {
  props: {
    // 1 添加 2 详情
    addType: {
      type: Number,
      required: true
    },

    // 费用详情
    list: {
      type: Array,
      required: true
    },

    // 外部搜索条件
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 费用类型
    feeTypeOption: {
      type: Array,
      required: true
    },

    // 费用是否可编辑
    isAllowEdit: {
      type: Boolean,
      default: true
    },

    // 账单类型
    payableType: {
      type: Number,
      required: true
    }
  },

  data() {
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    return {
      addBatchFee: {
        addBatchFeeList: []
      },
      priceType,
      createUser: null,
      FEE_SOURCE,
      tableHeight: 200,
      tableKey: new Date().getTime()
    };
  },

  watch: {
    list: {
      handler(val) {
        this.addBatchFee.addBatchFeeList = cloneDeep(val);
        this.tableKey = new Date().getTime();
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.createUser = getUserIdAndNameObj();

    this.getTableHeight();
  },
  mounted() {
    // 页面加载的时候设置table的高度
    this.getTableHeight();
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.getTableHeight();
    };
  },

  methods: {
    // 获取table高度
    getTableHeight() {
      this.$nextTick(() => {
        const el = this.$refs.addBatchFee.$el;
        const top = el.offsetTop;
        this.tableHeight = document.body.clientHeight - (top + 77);
      });
    },
    // 费用类型切换
    addChangeFee(scope) {
      const row = this.feeTypeOption.find(item => {
        return item.code === scope.row.feeCode;
      });

      if (!row) { return; }

      this.addBatchFee.addBatchFeeList[scope.$index].feeName = row.displayName;
      this.addBatchFee.addBatchFeeList[scope.$index].businessType = row.businessType;
    },

    // 添加费用
    addCost() {
      const data = {
        ...ADD_DATA,
        createUser: this.$store.state.user.id, // 录入人员
        operator: this.$store.state.user.id,
        flatMethod: this.payableType === 5 ? '3' : ''
      };
      // 新增
      // if (this.addType === 1) {
      //   if (this.addBatchFee.addBatchFeeList.length === 0) {
      //     this.addBatchFee.addBatchFeeList.push(data);
      //   } else {
      //     this.$message.warning(this.$t('receivablePayable.OnlyOneChargeCanBeAdded')); // 只能添加一条费用
      //   }
      // } else {
      //   this.addBatchFee.addBatchFeeList.push(data);
      // }
      this.addBatchFee.addBatchFeeList.push(data);
      this.tableKey = new Date().getTime();
    },

    // 编辑费用-父组件调用获取费用列表数据
    submitEdit() {
      return new Promise((resolve) => {
        // 是否存在新增数据
        const arr = this.addBatchFee.addBatchFeeList.filter(item => item.isEdit);
        // 存在新增检验数据
        if (arr.length > 0) {
          this.$refs.addBatchFee.validate(valid => {
            // 验证成功
            if (valid) {
              resolve(arr);
            } else {
              // 验证失败
              resolve(null);
            }
          });
        } else {
          // 不存在，返回空
          resolve([]);
        }
      });
    },

    // 删除新增
    deleteCost(scope) {
      const API = this.payableType === 5 ? apiPayableExpenseDelete : apiPayableSiteExpenseDelete;
      if (scope.row.id) {
        API({ id: scope.row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.addBatchFee.addBatchFeeList.splice(scope.$index, 1);
          }
        });
      } else {
        this.addBatchFee.addBatchFeeList.splice(scope.$index, 1);
      }
    }
  }

};
</script>

<style scoped>

</style>
